import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {assignUserEntitlementsStateSelector} from './assign-user-entitlements-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {ResourceView} from 'src/modules/entitlements/typedef';

export const assignUserEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    {resourceIds?: string[], resourceQuery: string}
>('assignUserEntitlements');

export const assignUserEntitlementsActions = assignUserEntitlementsSlice.actions;
export const assignUserEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.userPage.assignEntitlements.result.cache;
export const assignUserEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.userPage.assignEntitlements.result;

export const assignUserEntitlementsResultSelector = getCachedTableResultSelector(
    assignUserEntitlementsCacheSelector,
    assignUserEntitlementsStateSelector,
);
